
import { useState } from 'react';

// なぜ無料で商品が貰えるのか説明コンポーネント
function WhyFreeProductsSection() {
  return (
    <div className="mt-16 bg-white rounded-3xl shadow-lg p-4 sm:p-8 border border-pink-100">
      <div className="text-center mb-6 sm:mb-8">
        <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
          なぜ無料で体験できるの？
        </h3>
        <p className="text-base sm:text-lg text-gray-600">
          仕組みを理解して、安心してご参加ください
        </p>
      </div>
      
      <div className="space-y-4 sm:space-y-6">
        <div className="flex items-start space-x-3 sm:space-x-4 bg-pink-50 rounded-2xl p-4">
          <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-pink-100 rounded-full flex items-center justify-center">
            <span className="text-lg sm:text-2xl">📦</span>
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
              1️⃣ 新商品には、実際に使った方の感想が必要です
            </h4>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              メーカーさんは、より良い商品を作るために、実際に使ってくださる方のご意見を大切にしています。
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3 sm:space-x-4 bg-yellow-50 rounded-2xl p-4">
          <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-yellow-100 rounded-full flex items-center justify-center">
            <span className="text-lg sm:text-2xl">💬</span>
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
              2️⃣ でも、忙しい毎日の中で感想をお聞かせいただくのは大変
            </h4>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
              そこで私たちが、メーカーさんと体験してくださる皆さまをつなぐお手伝いをしています。
            </p>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              皆さまには商品を無料で体験していただき、使い心地やご感想をお聞かせいただいています。
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3 sm:space-x-4 bg-rose-50 rounded-2xl p-4">
          <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-rose-100 rounded-full flex items-center justify-center">
            <span className="text-lg sm:text-2xl">💝</span>
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
              3️⃣ 皆さまの体験レポートが、次の素敵な商品を生み出します
            </h4>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              いただいたご意見は商品改善に活かされ、より多くの方に喜んでいただける商品づくりに貢献しています。
            </p>
          </div>
        </div>
      </div>
      
      <div className="mt-6 sm:mt-8 bg-gradient-to-r from-pink-50 to-yellow-50 rounded-2xl p-4 sm:p-6 border border-pink-200">
        <div className="flex items-center justify-center mb-3">
          <span className="text-2xl sm:text-3xl mr-3">💕</span>
          <h4 className="text-lg sm:text-xl font-bold text-gray-900">
            私たちの想い
          </h4>
        </div>
        <p className="text-center text-gray-800 font-medium text-base sm:text-lg">
          メーカーさん・体験者の皆さま・お客様のすべてが<br />
          笑顔になれる商品づくりのお手伝いをしています。
        </p>
      </div>
    </div>
  );
}

export default function HowItWorksSection() {
  const steps = [
    {
      number: 1,
      title: '応募',
      description: '基本情報をご入力して\nモニター友の会に応募',
      image: 'https://public.readdy.ai/ai/img_res/56212c07c61328383015eaba40301126.jpg',
      gradient: 'from-pink-400 to-pink-500',
      arrowColor: 'text-pink-300'
    },
    {
      number: 2,
      title: '採用',
      description: '5営業日以内に\n体験案件をご案内',
      image: 'https://readdy.ai/api/search-image?query=Email%20notification%20with%20approval%20checkmark%2C%20acceptance%20and%20confirmation%20concept%20illustration%20with%20yellow%20and%20amber%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=step2&orientation=squarish',
      gradient: 'from-yellow-400 to-yellow-500',
      arrowColor: 'text-yellow-300'
    },
    {
      number: 3,
      title: '商品体験',
      description: 'お送りした商品を\nご自宅でゆっくり体験',
      image: 'https://readdy.ai/api/search-image?query=Person%20trying%20product%20at%20home%20with%20happy%20expression%2C%20product%20testing%20and%20experience%20concept%20illustration%20with%20rose%20and%20coral%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=step3&orientation=squarish',
      gradient: 'from-rose-400 to-rose-500',
      arrowColor: 'text-rose-300'
    },
    {
      number: 4,
      title: '感想提出',
      description: '体験レポートを\nお聞かせください',
      image: 'https://readdy.ai/api/search-image?query=Person%20writing%20review%20and%20feedback%20on%20laptop%2C%20report%20submission%20concept%20illustration%20with%20purple%20and%20violet%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=step4&orientation=squarish',
      gradient: 'from-purple-400 to-purple-500',
      arrowColor: 'text-purple-300'
    },
    {
      number: 5,
      title: '活動完了',
      description: '活動協力費を\nお支払いします',
      image: 'https://readdy.ai/api/search-image?query=Payment%20completion%20with%20money%20and%20success%20symbols%2C%20reward%20and%20compensation%20concept%20illustration%20with%20green%20and%20emerald%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=step5&orientation=squarish',
      gradient: 'from-green-400 to-green-500',
      arrowColor: ''
    }
  ];

  return (
    <section id="flow" className="py-12 sm:py-20 bg-gradient-to-br from-pink-25 to-yellow-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            活動の流れ
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            簡単な手続きで、安心して商品体験活動にご参加いただけます
          </p>
        </div>

        <div className="relative">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6 sm:gap-8">
            {steps.map((step, index) => (
              <div key={index} className="text-center relative">
                <img 
                  src={step.image} 
                  alt={step.title}
                  className="w-40 h-40 object-cover rounded-2xl mx-auto mb-4 sm:mb-6 shadow-lg"
                />
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm whitespace-pre-line">
                  {step.description}
                </p>
                
                {/* Arrow for desktop */}
                {step.arrowColor && (
                  <div className="hidden md:block absolute top-16 sm:top-20 left-full w-full">
                    <i className={`ri-arrow-right-line text-xl sm:text-2xl ${step.arrowColor} absolute -left-4`}></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 sm:mt-16 bg-white rounded-3xl shadow-lg p-4 sm:p-8 border border-pink-100">
          <div className="text-center mb-6 sm:mb-8">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
              参加条件・大切なお約束
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            <div className="bg-pink-50 rounded-2xl p-6">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-heart-line text-pink-600 mr-2"></i>
                参加条件
              </h4>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li>• 18歳以上の方（女性を優先的に募集しています）</li>
                <li>• 日本国内在住の方</li>
                <li>• 商品体験後、体験レポートをご提供いただける方</li>
                <li>• メールでの連絡が可能な方</li>
                <li>• 当会の利用規約にご同意いただける方</li>
              </ul>
            </div>
            
            <div className="bg-yellow-50 rounded-2xl p-6">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-information-line text-yellow-600 mr-2"></i>
                大切なお約束
              </h4>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li>• 提供商品は商品改善のための体験が目的です</li>
                <li>• 率直で建設的なご意見をお聞かせください</li>
                <li>• 活動協力費は案件により異なります</li>
                <li>• 個人情報は適切に管理・保護いたします</li>
                <li>• 案件によっては参加をお断りする場合があります</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// なぜ無料で商品が貰えるのか説明コンポーネントをエクスポート
export { WhyFreeProductsSection };
